if( ! document.getElementById("reviewEmployeeModal") ) {
    return;
}

// Get modal elements for resume and cover letter
const reviewModal = document.getElementById("reviewEmployeeModal");

if(reviewModal) {
    // Get open buttons for both modals
    if(document.getElementById("openReviewModal")) {
        const openModalBtns = document.getElementById("openReviewModal");
        // Open the respective modal when the open button is clicked
        openModalBtns.addEventListener('click', function() {
            reviewModal.style.display = "block";
        });
    }

    // Get close buttons for both modals
    if(document.querySelector(".close")) {
        const closeModalBtns = document.querySelector(".close");
        // Close the modal when the close button is clicked
        closeModalBtns.addEventListener('click', function() {
            reviewModal.style.display = "none";
        });
    }
    
    // Close the modal if the user clicks outside of it
    window.addEventListener('click', function(event) {
        if (event.target === reviewModal) {
            reviewModal.style.display = "none";
        }
    });
}
